import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLogin: false,
        luyou: 1,
        nCount:0,
        userInfo: {},
        api: 'https://ld.api.cocorobo.cn/edu/', 
        // api: 'http://localhost:7003/edu/',
    },

    mutations: {
        update(state, [key, value]) {
            state[key] = value;
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/config/config.js